// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c377c3a1","879":"35278d0e"}[chunkId] + ".chunk.js";
};